import { render } from "./FriendLinks.vue?vue&type=template&id=34620a39&scoped=true"
import script from "./FriendLinks.vue?vue&type=script&lang=js"
export * from "./FriendLinks.vue?vue&type=script&lang=js"

import "./FriendLinks.vue?vue&type=style&index=0&id=34620a39&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34620a39"]])

export default __exports__